import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import URLUtils from '../../util/URLUtils'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import PhoneUpdatePageUI from './PhoneUpdatePageUI.js'

class PhoneUpdatePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      captchaKey: null,
      messageList: null,
      socialLoginUrl: null,
      signUpWithPassword: false,
      // old phone number
      oldPhoneNumber: '',
      oldPhoneNumberError: null,
      // new phone number
      newPhoneNumber: '',
      newPhoneNumberError: null,
      // verification code
      verifCode: '',
      verifCodeError: null,
      // view
      view: 'phoneNumber' // other values 'verification', 'pinCode'
    }
  }

  render() {
    return (
      <PhoneUpdatePageUI
        context={this.props.context}
        messageList={this.state.messageList}
        onUpdatePhoneComplete={this.onUpdatePhoneComplete}
        // old phone number
        oldPhoneNumber={this.state.oldPhoneNumber}
        onOldPhoneNumberChange={(value) => { this.setState({ oldPhoneNumber: value }) }}
        oldPhoneNumberError={this.state.oldPhoneNumberError}
        setOldPhoneNumberError={(error) => { this.setState({ oldPhoneNumberError: error }) }}
        // new phone number
        newPhoneNumber={this.state.newPhoneNumber}
        onNewPhoneNumberChange={(value) => { this.setState({ newPhoneNumber: value }) }}
        newPhoneNumberError={this.state.newPhoneNumberError}
        setNewPhoneNumberError={(error) => { this.setState({ newPhoneNumberError: error }) }}
        // verification code
        verifCode={this.state.verifCode}
        onVerifCodeChange={(event) => { this.setState({ verifCode: event.target.value }) }}
        verifCodeError={this.state.verifCodeError}
        setVerifCodeError={(error) => { this.setState({ verifCodeError: error }) }}
        // view
        view={this.state.view}
        setView={(view) => { this.setState({ view: view }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getUser(context)
    this.getMessages(context)
  }

  getUser(context) {
    let cacheManager = new CacheManager({
      resource: '/api/user',
      cacheKey: CacheKeys.User(context.session.userId),
      callback: this.getUserCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getUserCallback = (response) => {
    this.setState({ errorList: response.errorList, oldPhoneNumber: response.phoneNumber })
  }

  onSignUpWithPasswordClick = (event) => {
    this.setState({ signUpWithPassword: true })
  }

  getCaptchaPublicKey(context) {
    let cacheManager = new CacheManager({
      resource: '/api/pub/reCaptcha/publicKey',
      cacheKey: CacheKeys.CaptchaKey,
      callback: this.getCaptchaPublicKeyCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, {})
  }

  getCaptchaPublicKeyCallback = (response) => {
    this.setState({ captchaKey: response.publicKey })
  }

  getSocialLoginUrl(context) {
    let cacheManager = new CacheManager({
      resource: '/api/pub/socialLoginUrl',
      cacheKey: CacheKeys.SocialLoginUrl,
      callback: this.getSocialLoginUrlCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { baseUrl: URLUtils.getBaseURL() })
  }

  getSocialLoginUrlCallback = (response) => {
    this.setState({ socialLoginUrl: response })
  }

  onUpdatePhoneComplete = () => {
    CacheManager.removeObject(CacheKeys.User(this.props.context.session.userId));
    setTimeout(() => {
      this.props.history.push(`/settings/user/fin`)
    }, 3000)
  }

  getMessages(context) {
    let arr = [
      'c_update_phone_number',
      'c_verify_new_phone',
      'c_re_update_phone'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_phone_upd', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }

}

export default withRouter(PhoneUpdatePageSF)
